import React, { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "../common/app-header/app-header";
import { useWindowDimensions } from "../common/windowDimensions";
import LeftSlider from "./left-slider/left-slider";
import { ConfigProvider, Layout, Spin } from "antd";
import { ErrorBoundary } from "../common/error-boundary/error-boundary";
import { Content } from "antd/es/layout/layout";
import * as accountService from "./../service/accountService";
import { encryptData, SECRET_KEY } from "../util/encryption";
import { LocalStorageKeys } from "../constants/localStorageKeys";
import * as localStorageService from "./../service/localStorageService";
import { useStore } from "./../store/store";
import './auth-layout.scss'
import { CommonConstants } from "../constants/commonConstants";
const AuthLayout = () => {
  const { width } = useWindowDimensions();
  const onLeftSiderCollapse = (isMenuOpen) => {
    setIsLeftMenuOpen(isMenuOpen);
  };
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(true);
  const [isWaitLanguage, setIsWaitLanguage] = useState(false);
  const [direction, setDirection] = useState("ltr");
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const { user, saveUser } = useStore();

  useEffect(() => {
    //if (!user?.userId) {
      getUserDetail();
    // } else {
    //   setIsUserLoaded(true);
    // }
  }, []);

  const getUserDetail = () => {
    accountService
      .getUserDetail()
      .then((res) => {
        let user=res.data.data;
        let lang = localStorageService.getValue(LocalStorageKeys.Lang);
        if (lang == null) {
          lang = CommonConstants.DefaultLanguageCode;
        }
        user.selectedLanguage= lang;
        saveUser(user);

        setIsUserLoaded(true);
      })
      .catch((error) =>
        console.error("Error while fetching user detail", error)
      );
  };
  const getDirection=()=>{
    if(user?.selectedLanguage){
        if (user.selectedLanguage==CommonConstants.ArabicLanguageCode){
          return "rtl";
        }else{
          return "ltr";
        }
    }
    else{
      if(localStorageService.getValue(LocalStorageKeys.Lang)==CommonConstants.ArabicLanguageCode){
        return "rtl"
      }
      else{
        return "ltr";
      }
    }
    
  }
  return (
    <div>
      <Layout className="authLayout-wrapper">
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Silka Regular",
              colorPrimary: "#FF5D00",
            },
          }}
          direction={
            getDirection()
          }
        >
          <LeftSlider onCollapse={onLeftSiderCollapse} />

          <Layout style={{ display: "flex", flexDirection: "column", flex: 1 }}>

            <ErrorBoundary>
              <Content className="content-body-wrapper">
                  <AppHeader />
                  <Suspense
                    fallback={
                      <Spin
                        style={{ marginLeft: "50%", marginTop: "10%" }}
                      ></Spin>
                    }
                  >
                    {!isUserLoaded && (
                      <Spin
                        style={{ marginLeft: "50%", marginTop: "10%" }}
                      ></Spin>
                    )}
                    {isUserLoaded && <Outlet />}
                  </Suspense>
              </Content>
            </ErrorBoundary>
          </Layout>
        </ConfigProvider>
      </Layout>
    </div>
  );
};

export default AuthLayout;
